import { Component, OnInit, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import Ticket from 'models/ticket/ticket.model';
import Project from 'models/project/project.model';
import ExternalLayer from 'models/external-layer/external-layer.model';
import GeoJSONPoint from 'models/geojson-point/geojson-point.model';
import { TicketAttributeService } from 'services/ticket-attribute/ticket-attribute.service';

@Component({
  selector: 'app-esri-ticket',
  templateUrl: './esri-ticket.component.html',
  styleUrls: ['./esri-ticket.component.scss'],
})
export class EsriTicketComponent implements OnInit {
  @Input() pointsToShow: BehaviorSubject<GeoJSONPoint<{}>[]> = new BehaviorSubject([]);
  @Input() filteredPoints: BehaviorSubject<Ticket[]> = new BehaviorSubject([]);
  @Input() public project: Project = new Project();
  @Input() public refSubject = new BehaviorSubject<boolean>(false);

  public layerListSubject: BehaviorSubject<ExternalLayer[]> = new BehaviorSubject([]);
  
  constructor(
    public ticketAttributeService: TicketAttributeService,
  ) { }

  async ngOnInit() {
    this.layerListSubject.next(this.project.externalLayers);
    await this.ticketAttributeService.selectList(this.project);
  }
}
